






































































import Vue from "vue";
// TODO : eslintでno-unused-varsのwarningが出ているので、Vue3へのアップデート時に対応検討する
import InvestmentOption, { InvestmentOptionType } from "@components/partials/public/projects/InvestmentOption.vue";

// 特定投資家向けのcomponentでも利用するためexport
// TODO : 汎用的なtypeの置き場所を作ったら移動する
export type ProjectType = {
  id: number
  name: string
  targetOfferingAmount: number
  maximumOfferingAmount: number
  stockIssueAmount: number
  investmentStockUnit: number
  minimumInvestableAmount: number
  targetOfferingStock: number
  maximumOfferingStock: number
  remainingNumberOfStocks: number
}

type DataType = {
  project: ProjectType,
  InvestmentOptions: Array<InvestmentOptionType>,
  isProfessionalInvestor: boolean,
  options: Record<string, unknown>
}

export default Vue.extend({
  components: {
    InvestmentOption
  },
  props: {
    projectJsonString: {
      type: String,
      required: true,
    },
    investmentOptionsJsonString: {
      type: String,
      required: true,
    },
    isProfessionalInvestorString: {
      type: String,
      required: true,
    }
  },
  // TODO : DataTypeの型判定が機能していないので使い方調べる
  data(): DataType {
    const project = JSON.parse(this.projectJsonString);
    const investmentOptions = JSON.parse(this.investmentOptionsJsonString);
    const isProfessionalInvestor: boolean = this.isProfessionalInvestorString === "true"
    return {
      project,
      investmentOptions,
      isProfessionalInvestor,
      options: {
        width: "90%",
        maxWidth: 600,
        height: "auto",
      }
    };
  },
  computed: {
    hasUninvestableOptionByInvestorLimit(): boolean {
      return this.investmentOptions.some((investmentOption) => investmentOption.withinInvestorInvestmentAmountLimit === false)
    },
    hasUninvestableOptionByProjectLimit(): boolean {
      return this.investmentOptions.some((investmentOption) => investmentOption.withinProjectInvestmentAmountLimit === false)
    }
  },
  methods: {
    modalShow(): void {
      this.$modal.show('investmentOptionSelectModal');
    },
  }
});
